import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { BoilerList } from 'z3k-settings/climatic/boilers/ui/boiler-list';
import { useBoilersState } from 'z3k-settings/climatic/boilers/lib/useBoilersState';
import { CascadeList } from 'z3k-settings/climatic/boilers/ui/cascade-list';
import { unpack_validation } from 'z3k-parser/validation/types';
export function ClimaticBoilers() {
    const { enabled_boilers, state } = useBoilersState();
    return (_jsxs(Box, { display: "flex", flexDirection: "column", sx: { gridRowGap: '1em', px: '16px' }, children: [_jsx(BoilerList, {}), enabled_boilers.length >= 2 && _jsx(CascadeList, {}), enabled_boilers.length == 0 && (_jsxs(Box, { display: "flex", flexDirection: "column", mt: 4, children: [_jsx(Typography, { color: "textSecondary", children: "\u0422\u0435\u043F\u043B\u043E\u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u044B \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u044B" }), _jsx(Typography, { color: "textSecondary", children: "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0438\u0445 \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F" })] }))] }));
}
ClimaticBoilers.isWarning = () => false;
ClimaticBoilers.isError = (validation_result) => {
    const heating_circuits = unpack_validation(validation_result, 'heating_circuits');
    return !!(unpack_validation(validation_result, 'boiler_cascades') ||
        (heating_circuits instanceof Array &&
            heating_circuits.slice(0, 2).some((item, index) => {
                if (unpack_validation(heating_circuits, index, 'name') != null) {
                    return false;
                }
                return item != null;
            })));
};
ClimaticBoilers.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return is_service_view && is_climatic;
};
